import { getIntervalDifferenceLabel } from '@utils/granularity';

export enum Tabs {
  TopTrends,
  ViewerSessions,
  TopImpactedViewers,
  AppViewSessions,
}

export const DIMENSION_WRAPPER_ID = 'dimension-panel-wrapper';
export const TABLE_COMPARE_COLOR = 'rgba(60, 60, 60, 0.2)';
export const TABLE_COMPARE_OPACITY = '4D';

export const getCompareIntervalLabel = ({ isSliceAvailable, dodEnabled, compareInterval }) => {
  if (isSliceAvailable) {
    return `Compare prev ${getIntervalDifferenceLabel(compareInterval)}`;
  } else if (dodEnabled) {
    return 'Date Comparison';
  }
  return 'Table Compare';
};

export const getCompareTooltipText = ({ isCompareToggleEnabled, isValidCompareInterval }) => {
  switch (true) {
    case !isCompareToggleEnabled:
      return 'Turn on Date Comparison or Slice the metric chart to enable Table Compare.';

    case !isValidCompareInterval:
      return 'Comparison unavailable';

    default:
      return '';
  }
};
